import _isNil from 'lodash/isNil';
import _isString from 'lodash/isString';
import { v4 as uuidv4, v5 as uuidv5 } from 'uuid';

export function generateAlphabeticUuid({ length = 36, seed = null } = {}) {
  let baseUuid;

  if (_isNil(seed)) {
    baseUuid = uuidv4().replace(/-/g, '');
  } else {
    const NAMESPACE = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
    const inputSeed = _isString(seed) ? seed : JSON.stringify(seed);
    baseUuid = uuidv5(inputSeed, NAMESPACE).replace(/-/g, '');
  }

  let alphabeticUuid = '';
  for (let i = 0; i < length; i += 1) {
    const hexChar = baseUuid[i % baseUuid.length];
    const hexValue = parseInt(hexChar, 16);
    const charCode = 97 + (hexValue % 26);
    alphabeticUuid += String.fromCharCode(charCode);
  }

  return alphabeticUuid;
}
